import type { OrganizationRiskSetting } from '@app/src/types/resourceExplorer'
import React, { useState } from 'react'
import RiskIndexFilterBar from './RiskIndexFilterBar'
import type { RiskIndexFilterState } from './riskIndexFilters'
import { filterRiskSettings, NO_RISK_INDEX_FILTERS } from './riskIndexFilters'
import RiskSettingsTable from './RiskSettingsTable'

interface StandaloneRiskIndicesProps {
  settings: OrganizationRiskSetting[]
  isEditMode: boolean
  isLoading: boolean
  isError: boolean
  onToggleChange: (riskIndexId: number, isActivated: boolean) => void
  modifiedRiskStates: Map<number, boolean>
}

const StandaloneRiskIndices: React.FC<StandaloneRiskIndicesProps> = ({
  settings,
  isEditMode,
  isLoading,
  isError,
  onToggleChange,
  modifiedRiskStates,
}) => {
  const [filters, setFilters] = useState<RiskIndexFilterState>(NO_RISK_INDEX_FILTERS)

  return (
    <>
      <RiskIndexFilterBar filters={filters} onChange={setFilters} />
      <RiskSettingsTable
        settings={filterRiskSettings(settings, filters)}
        isEditMode={isEditMode}
        isLoading={isLoading}
        isError={isError}
        onToggleChange={onToggleChange}
        modifiedRiskStates={modifiedRiskStates}
        filterDependencies={[filters]}
      />
    </>
  )
}

export default StandaloneRiskIndices
